<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 3a1 1 0 10-2 0h2zm-1 18l-.707.707a1 1 0 001.414 0L12 21zm5.707-4.293a1 1 0 00-1.414-1.414l1.414 1.414zm-10-1.414a1 1 0 00-1.414 1.414l1.414-1.414zM11 3v18h2V3h-2zm1.707 18.707l5-5-1.414-1.414-5 5 1.414 1.414zm0-1.414l-5-5-1.414 1.414 5 5 1.414-1.414z"/></svg>